import { ThemedStyleFn } from '~src/hooks/useStyles';

export const styleFn: ThemedStyleFn = (theme) => ({
  groupCardFileWrapper: {
    width: '100%',
    // backgroundColor: 'pink',
    // display: 'flex',
    // alignItems: 'center',
    // gap: '10px',

    '& .ant-upload-list': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      marginLeft: '8px',
      marginTop: '5px',
    },

    '& .ant-upload-list-item': {
      display: 'flex',
      alignItems: 'center',
      // Adjust the spacing or minWidth if needed
    },

    // Make the PDF icon and paperclip icon bigger
    '& .ant-upload-list-item .anticon': {
      fontSize: '18px', // <--- Increase icon size
      width: '18px', // optional if you want bigger bounding
      height: '18px', // optional if you want bigger bounding
      lineHeight: '18px', // keep icons vertically aligned
      backgroundColor: 'blue',
    },

    // Specifically enlarge the remove/delete icon
    '& .ant-upload-list-item-card-actions .anticon-delete, .ant-upload-list-item-card-actions .anticon-close': {
      fontSize: '18px',
      width: '18px',
      height: '18px',
    },
  },

  draggerContainer: {
    width: '100%',
    height: '100%',
    // backgroundColor: 'red',
  },
});
